import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgChevronUp = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "inherit",
		fillRule: "evenodd",
		transform: "rotate(-180 6,3.9669997692108154)",
		d: "m6,7.667l-6,-6l1.4,-1.4l4.6,4.6l4.6,-4.6l1.4,1.4l-6,6z"
	})
});
export default SvgChevronUp;
